import { IState } from '../../store';

export const selectPhoneWarningTarget = (state: IState) => {
  return state.phoneWarning.target;
};
